export enum QesFileType {
  Xml = 'Xml',
  Pdf = 'Pdf',
}
